import Icon from '../components/Icon.vue'

Icon.register({
  'holly-berry': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M144 192C170.5 192 192 170.5 192 144S170.5 96 144 96 96 117.5 96 144 117.5 192 144 192zM256 144C256 170.5 277.5 192 304 192S352 170.5 352 144 330.5 96 304 96 256 117.5 256 144zM224 96C250.5 96 272 74.5 272 48S250.5 0 224 0 176 21.5 176 48 197.5 96 224 96zM207.8 235.1C207.9 222.7 194.7 215 184 221.4 149.7 241.7 112.6 254.1 75.3 257.6 65.6 258.5 59.7 268.9 63.7 277.8 69.9 291.7 74.8 306.4 78.4 321.6 82 336.8 73.1 352.2 58.2 356.7 43.3 361.2 28.1 364.3 12.9 365.8 3.2 366.8-2.8 377.1 1.2 386 16.2 418.8 24.1 455.5 24.2 493.7 24.3 508.1 39.4 516.8 51.8 509.7 85 490.7 120.7 479.2 156.6 475.8 166.3 474.9 172.2 464.5 168.2 455.6 162 441.7 157.1 427 153.5 411.8 149.9 396.6 158.8 381.2 173.7 376.7 188.6 372.2 203.8 369.1 219 367.6 228.7 366.6 234.7 356.3 230.7 347.4 215.2 313.2 207.4 274.9 207.8 235.1zM435 365.6C419.8 364 404.7 360.9 389.7 356.5 374.8 352 365.9 336.6 369.5 321.4 373.1 306.2 378 291.6 384.2 277.6 388.2 268.7 382.3 258.3 372.6 257.4 335.3 253.9 298.2 241.5 263.9 221.2 253.2 214.9 240 222.6 240.1 234.9 240.1 236.5 239.9 238.1 239.9 239.8 240.1 273.1 246.9 305.5 259.8 333.8 265.5 346.2 265 360.4 259.2 372.7 264.1 373.9 269.1 374.9 274 376.4 288.9 380.9 297.8 396.3 294.2 411.5 290.6 426.7 285.7 441.3 279.5 455.3 275.5 464.2 281.4 474.6 291.1 475.5 327 478.9 362.7 490.4 395.9 509.4 408.4 516.5 423.5 507.8 423.5 493.4 423.7 455.2 431.5 418.4 446.5 385.7 450.8 377 444.7 366.6 435 365.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/holly-berry.js
// module id = 8euj
// module chunks = 144